var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:{ 'instance-name-header': true, 'primary-background': _vm.primaryBackground }},[_c('span',[_vm._v(_vm._s(_setup.store.config.id))]),_c('span',[_vm._v(".aktivisda")])])
}
var staticRenderFns = []

export { render, staticRenderFns }